<template>
  <tr>
    <th>
      車両タイプ
      <span class="must">必須</span>
    </th>
    <td>
      <div class="row">
        <!--
        入れ替え車の場合、なぜか選択肢が「はい」「いいえ」になる事象が発生。
        そして、下記の意味ないようなif文を入れると何故か解決するので消さないこと
        -->
        <div v-if="isIrekae" class="col-md-9 col-lg-5">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="SYARYO_TYPE_KBN"
          >
            <b-form-select
              ref="SYARYO_TYPE_KBN"
              v-model="syaryo.SYARYO_TYPE_KBN"
              :state="errors.length ? false : null"
              :options="syaryoTypeKbnList"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </div>
        <div v-else class="col-md-9 col-lg-5">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="SYARYO_TYPE_KBN"
          >
            <b-form-select
              ref="SYARYO_TYPE_KBN"
              v-model="syaryo.SYARYO_TYPE_KBN"
              :state="errors.length ? false : null"
              :options="
                [{ value: '', text: '未選択' }].concat(...syaryoTypeKbnList)
              "
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </div>
        <div v-if="isSyaryoTypeKbnOther" class="row col-md-9 col-lg-7">
          <span class="ml-3 mt-2">
            <strong>その他詳細</strong>
          </span>
          <div class="col-lg-9">
            <validation-provider
              name="SYARYO_TYPE_DETAIL"
              v-slot="{ errors }"
              rules="max:30|char"
            >
              <b-form-input
                ref="SYARYO_TYPE_DETAIL"
                v-model="syaryo.SYARYO_TYPE_DETAIL"
                maxlength="30"
                :state="errors.length ? false : null"
                trim
                @blur="
                  syaryo.SYARYO_TYPE_DETAIL = replaceChar(
                    syaryo.SYARYO_TYPE_DETAIL
                  )
                "
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
        </div>
      </div>
      <div v-if="isSyaryoTypeKbnTruckOrBuss">
        <div>
          <validation-provider
            name="SYARYO_SHAPE_TYPE"
            v-slot="{ errors }"
            :rules="{ required: isSyaryoTypeKbnTruckOrBuss }"
          >
            <div class="mt-4"><strong>形状</strong></div>
            <b-form-radio-group
              ref="SYARYO_SHAPE_TYPE"
              v-model="syaryo.SYARYO_SHAPE_TYPE"
              :state="errors.length ? false : null"
              :options="filteredSyaryoShapeList"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div v-if="isSyaryoShapeOther" class="mt-2 row">
          <span class="ml-3 mt-2">
            <strong>その他詳細</strong>
          </span>
          <div class="col-md-10">
            <validation-provider
              name="SYARYO_SHAPE_DETAIL"
              v-slot="{ errors }"
              rules="max:20|char"
            >
              <b-form-input
                ref="SYARYO_SHAPE_DETAIL"
                v-model="syaryo.SYARYO_SHAPE_DETAIL"
                maxlength="20"
                :state="errors.length ? false : null"
                placeholder="荷台にタイヤが乗っている等"
                trim
                @blur="
                  syaryo.SYARYO_SHAPE_DETAIL = replaceChar(
                    syaryo.SYARYO_SHAPE_DETAIL
                  )
                "
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
        </div>
        <p v-else-if="isSyaryoShapeKitchenOrCamp" class="mt-2 red f-size-12">
          ※プロパンガスや、発火の恐れがある物が車載された車両は乗船不可となる為、陸送方法が変更となる場合がございます。
        </p>
      </div>
    </td>
  </tr>
</template>

<script>
import Mixin from '../mixin/Mixin'
export default {
  name: 'SyaryoTypeDetail',
  mixins: [Mixin],
  props: {
    syaryo: {
      type: Object,
      required: true,
    },
    isIrekae: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getRefs() {
      return this.$refs
    },
  },
  computed: {
    /** 車両タイプ バスか */
    isSyaryoTypeKbnBuss() {
      return this.syaryo.SYARYO_TYPE_KBN === 7
    },

    /** 車両タイプ トラック/バスか */
    isSyaryoTypeKbnTruckOrBuss() {
      return (
        this.isSyaryoTypeKbnBuss || [5, 6].includes(this.syaryo.SYARYO_TYPE_KBN)
      )
    },

    /** 車両タイプ その他か */
    isSyaryoTypeKbnOther() {
      return this.syaryo.SYARYO_TYPE_KBN === 9
    },

    /** 車両形状 キッチンカー/キャンピングカーか */
    isSyaryoShapeKitchenOrCamp() {
      return [7, 8].includes(this.syaryo.SYARYO_SHAPE_TYPE)
    },

    /** 車両形状 その他か */
    isSyaryoShapeOther() {
      return this.syaryo.SYARYO_SHAPE_TYPE === 99
    },

    /** 車両形状 */
    filteredSyaryoShapeList() {
      return this.isSyaryoTypeKbnBuss
        ? // バスの場合は、ノーマル、キッチンカー、キャンピングカー、その他
          this.syaryoShapeTypeList.filter((item) =>
            [6, 7, 8, 99].includes(item.value)
          )
        : this.syaryoShapeTypeList.filter((item) => item.value !== 6)
    },
  },
  watch: {
    'syaryo.SYARYO_TYPE_KBN'() {
      if (
        !this.filteredSyaryoShapeList.find(
          (item) => item.value === this.syaryo.SYARYO_SHAPE_TYPE
        )
      ) {
        this.syaryo.SYARYO_SHAPE_TYPE = null
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
    padding: 10px
</style>



// WEBPACK FOOTER //
// src/components/order/SyaryoTypeDetail.vue